import React from 'react';

import { Modal } from '@copilot/ui';
import DesktopDownload from './DesktopDownload';

/**
 * The download choices, shown over the app instead of navigating to
 * /download.
 *
 * Why a modal: picking a download is one short decision, and sending
 * someone to a standalone page for it threw them out of the product -
 * out of the shell, with only the browser's back button to return.
 * Closing this puts them back exactly where they were.
 *
 * The public /download page still exists and is still what the
 * marketing site links to; both render the same `DesktopDownload`.
 */
function DesktopDownloadModal({ onClose }) {
  return (
    <Modal
      title="Get KrishvaQ for desktop"
      subtitle="Native audio capture and a private overlay above your meeting."
      size="md"
      onClose={onClose}
    >
      <DesktopDownload compact />
    </Modal>
  );
}

export default DesktopDownloadModal;
